import { Component, OnInit } from '@angular/core';
import { GraphService } from '../../General/graph/graph.service';
import { TopicService } from '../../optimal-solutions/topic.service';
import { ActivatedRoute } from '@angular/router';
import { TeacherGraphExerciseComponent } from '../../shared/interactive-graph/exercise_components/teacher-graph-exercise.component';
import { InteractiveGraph } from 'graph-interactive/dist/lib/interactive/interactiveGraph';
import { GraphUW } from '../../shared/interactive-graph/simple_graphs/graphUW';
import { GraphServiceJson, GraphAlgorithm, GraphRandom } from 'graph-interactive';

@Component({
  selector: 'app-t-minimum-spanning-tree',
  templateUrl: './t-minimum-spanning-tree.component.html',
  styleUrls: ['./t-minimum-spanning-tree.component.css']
})
export class TMinimumSpanningTreeComponent extends TeacherGraphExerciseComponent {

  private readonly canvasID: string = 'graph-canvas';
  private readonly solutionID: string = 'solutionButton';

  constructor(protected topicsService: TopicService, protected activatedRoute: ActivatedRoute, graphService: GraphService) {
    super(topicsService, activatedRoute);
    this.type = 'minimumSpanningTree';
    this.title = this.get('minimumSpanningTree');
    this.description = this.get('descriptionMinimumSpanningTree');
  }

  
  generate(){
    GraphRandom.generateGraph(this.graph);
  }

  initGraph(): InteractiveGraph {
    const canvas = <HTMLCanvasElement>document.getElementById(this.canvasID);
    const solButton = <HTMLButtonElement> document.getElementById(this.solutionID);
    solButton.addEventListener('click', this.onSolution, false);
    return new GraphUW(canvas);
  }

  generateDefinition(): any {

    const definition: any = {};
    if (this.id === undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = './assets/images/minimumSpanningTree.png';
    definition.key = 'minimumSpanningTree%'.concat(this.type, '%' + this.id);
    if (this.examId > -1) {
      definition.key = definition.key.concat('exam%', this.examId.toString(), '%');
    }

    GraphServiceJson.exportGraph(this.graph, definition);

    return definition;
  }

  onSolution = () =>{
     let solEdges = GraphAlgorithm.primMST(this.graph.getGraph());
     this.graph.highLight(null, solEdges);
     this.graph.forceUpdate();
  }

  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();

  }


}


